export { default } from '@mui/base/NoSsr';